import { useState, useCallback } from 'react'
import { TOUR_COMPLETED_KEY } from './tourSteps'

/**
 * Hook for managing guided tour progress state
 *
 * Tracks completion in localStorage so tour doesn't auto-run
 * for returning users.
 */
export function useTourProgress() {
  const [hasCompletedTour, setHasCompletedTour] = useState(() =>
    typeof window !== 'undefined' && localStorage.getItem(TOUR_COMPLETED_KEY) === 'true'
  )

  const markTourCompleted = useCallback(() => {
    localStorage.setItem(TOUR_COMPLETED_KEY, 'true')
    setHasCompletedTour(true)
  }, [])

  const resetTour = useCallback(() => {
    localStorage.removeItem(TOUR_COMPLETED_KEY)
    setHasCompletedTour(false)
  }, [])

  return { hasCompletedTour, markTourCompleted, resetTour }
}
